(function () {
	'use strict';

	/**
	 * @ngdoc component
	 * @name mx.components:mxItemChooser
	 * @module mx.components
	 * @restrict 'E'
	 * @scope {}
	 * @description Custom bottom sheet component
	 * @usage <mx-item-chooser
	 *        top-offset='24px'
	 *        options='{
	 *			icon:'apps',
	 *			displayMode: 'grid',
	 *			controller: 'ItemChooserController'*
	 * 		}'>
	 * </mx-item-chooser>
	 * @param {string} top-offset= The offset regarding top position of his parent element:
	 * @param {object} options= An options object, with the following properties:
	 *   - `icon`        - `{string=}`: The icon to associate with button showing this bottom sheet.
	 *   - `displayMode`- `{string=}`: Represents one of two modes of displaying: 'grid' or 'list'.
	 *   - `controller` - `{string=}`: The controller to associate with this bottom sheet.
	 */
	angular.module('mx.components').component('mxItemChooser', {
		bindings: {
			isEnabled: '&',
			topOffset: '@',
			options: '<',
		},
		controller: MxItemChooserCtrl,
		controllerAs: 'vm',
	});

	MxItemChooserCtrl.$inject = [
		'$scope',
		'$http',
		'$templateCache',
		'$compile',
		'$mdBottomSheet',
		'$q',
		'$window',
		'$mdUtil',
		'mx.internationalization',
		'$element',
		'mx.app.ColorService',
		'mx.app.ThemeService',
	];

	function MxItemChooserCtrl($scope, $http, $templateCache, $compile, $mdBottomSheet, $q, $window, $mdUtil, i18n, $element, colorService, themeService) {
		var vm = this;
		var buttonsSelector = 'md-bottom-sheet .md-button:not([disabled])';

		vm.$onInit = function () {
			vm.dialogActive = false;
			vm.toggleDialog = toggleDialog;
			vm.executeItem = executeItem;
			vm.focusItem = focusItem;
			vm.closeItemChooser = closeItemChooser;
			vm.arrowsNavigate = arrowsNavigate;
			initItemColor();
			angular.element($window).on('click', function ($event) {
				if (vm.dialogActive) {
					vm.closeItemChooser();
					$event.stopPropagation();
				}
			});
		};

		vm.$postLink = function () {
			link($scope, $element, vm, i18n, $http, $q, $templateCache, $compile);
		};

		return vm;

		function closeItemChooser() {
			if (vm.dialogActive) {
				// $mdBottomSheet.hide();
				$mdUtil.nextTick($mdBottomSheet.cancel, true);
				vm.dialogActive = false;
			}
		}

		function toggleDialog(options) {
			if (vm.dialogActive) {
				vm.closeItemChooser();
			} else {
				var _templateUrl = 'mx-item-chooser/' + (options.displayMode === 'grid' ? 'mx-item-chooser-grid-template.html' : 'mx-item-chooser-list-template.html');

				$mdBottomSheet.show({
					templateUrl: _templateUrl,
					controller: options.controller,
					//disableBackdrop: true,
					disableParentScroll: false,
					parent: vm.parent,
					controllerAs: 'vm',
					bindToController: true,
					locals: {
						execute: vm.executeItem,
						focus: vm.focusItem,
						topOffset: vm.topOffset,
						arrowsNavigate: vm.arrowsNavigate,
					},
				});

				vm.dialogActive = true;

				setTimeout(function () {
					$($(buttonsSelector)[0]).focus();
				}, 1);
			}
		}

		function arrowsNavigate($event) {
			var idx,
				activeBtn = $(document.activeElement),
				btns;
			if ([37, 38, 39, 40].indexOf($event.which) !== -1 && activeBtn.is(buttonsSelector)) {
				btns = $(buttonsSelector);
				idx = btns.index(activeBtn[0]);
				if ([37, 38].indexOf($event.which) > -1 && idx > 0) {
					btns[idx - 1].focus();
				}
				if ([39, 40].indexOf($event.which) > -1 && idx < btns.length - 1) {
					btns[idx + 1].focus();
				}
			}
		}

		function executeItem(item, $event) {
			// If Left or Middle mouse button, enter or space
			if ($event.which === 1 || $event.which === 2 || $event.which === 13 || $event.which === 32) {
				vm.closeItemChooser();

				if (angular.isDefined(item) && angular.isFunction(item.execute)) {
					item.execute($event);
				}
			}
		}

		function focusItem(item) {
			if (angular.isDefined(item) && angular.isDefined(item.isFocused)) {
				return item.isFocused;
			}

			return false;
		}

		async function initItemColor() {
			const currentTheme = await themeService.getCurrentTheme();
			const color =
				Math.abs(colorService.getLightness(currentTheme['content-bg-color']) - colorService.getLightness(currentTheme['header-icon-color'])) >
				Math.abs(colorService.getLightness(currentTheme['content-bg-color']) - colorService.getLightness(currentTheme['header-bg-color']))
					? currentTheme['header-icon-color']
					: currentTheme['header-bg-color'];

			$element.css('--mx-item-chooser-icons-color', color);
		}
	}

	function link(scope, element, vm, i18n, $http, $q, $templateCache, $compile) {
		element.addClass('mx-item-chooser-control-container');

		var isEnabled = vm.isEnabled();
		if (angular.isUndefined(isEnabled)) {
			isEnabled = true;
		}
		if (!isEnabled) {
			return;
		}
		isEnabled = $q.when(isEnabled);
		isEnabled.then(function (value) {
			if (!value) {
				return;
			}
			$http.get('mx-item-chooser/mx-item-chooser.html', { cache: $templateCache }).then(function (response) {
				var template = $compile(response.data)(scope);
				element.append(template);
				load(scope);
			});
		});

		function load() {
			vm.internationalization = i18n.get('components.mx-item-chooser');

			vm.parent = element[0];
		}
	}
})();
